import React from "react";
import { Card, Divider, Modal } from "antd";
import Button from "./button";
import moment from "moment";

const OrderTimeModal = ({ onCancel, data, onOk, text, title }) => {
  const dateTime = (
    <div>
      <span className="text-primaryPurple text-md font-medium">
        Appointment Date & Time{" "}
      </span>
      {data?.items?.map((item, i) => {
        const date = new Date(item?.appointmentDateTime);
        const utcDateTime = date.toLocaleString("en-US", { timeZone: "UTC" });
        return (
          <p className="font-medium mt-0" key={i}>
            {utcDateTime}
          </p>
        );
      })}
    </div>
  );
  const orderItem = data?.items?.map((item, i) => {
    return item;
  });
  const appointmentsItem = orderItem?.map((item) => {
    return {
      serviceName: item?.serviceDetails?.serviceName || item?.serviceId?.serviceName,
      appointment: item?.appointmentDateTime,
    };
  });
  return (
    <div>
      <Modal
        open={true}
        footer={null}
        maskClosable={true}
        closeIcon={null}
        className="space-y-20"
        onCancel={onCancel}
        width="479px"
      >
        <div className="text-primaryPurple font-bold text-lg">
          Appointment Date & Time
        </div>
        <Divider className="m-0 mt-1" />
        <div className="grid grid-cols-2 border border-grey-600 ">
          <div className="grid grid-cols-1  ">
            <p className="text-primaryPurple font-bold text-lg">Service Name</p>
            {appointmentsItem?.map((item, i) => {
              if (item?.appointment) {
                return (
                  <div
                    className="grid grid-cols-2 border border-indigo-600 "
                    key={i}
                  >
                    <div className="" key={i}>
                      {item?.serviceName}
                    </div>
                  </div>
                );
              }
            })}
          </div>
          <div className=" border-1px ">
            <p className="text-primaryPurple font-bold text-lg">Date & Time</p>
            {appointmentsItem?.map((item, i) => {
              if (item?.appointment) {
                return (
                  <div className="border-1px" key={i}>
                    <span>
                      {item?.appointment
                        ? moment
                          .utc(item.appointment)
                          .local()
                          .format("MM/DD/YY hh:mm A")
                        : "No appointment date provided."}
                    </span>
                  </div>
                );
              }
            })}
          </div>
        </div>

        <div className="text-primaryPurple font-medium"></div>
      </Modal>
    </div>
  );
};
export default OrderTimeModal;
